import { Typography } from 'shared/ui'
import { type IPreviewBubble } from './Preview'
import styles from './styles.module.scss'

type IPreviewBubbleProps = {
  bubble: IPreviewBubble
}

export const PreviewBubble = ({ bubble }: IPreviewBubbleProps) => {
  const isOutbound = bubble.direction === 'outbound'
  const className = isOutbound ? styles.bubble : styles.replyBubble
  const variant = isOutbound ? 'body-md-regular' : 'body-rg-regular'

  return (
    <div className={className}>
      <Typography variant={variant} ariaLabel='previewBubble'>
        {bubble.parts.map((part, index) => (
          <span
            key={index}
            style={part.isPlaceholder ? { color: 'var(--content-neutral-primary)' } : undefined}
          >
            {part.text}
          </span>
        ))}
      </Typography>
    </div>
  )
}
